
import React from 'react';
import { Card, CardHeader, CardTitle, CardDescription, CardFooter } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { ChevronRight, TrendingUp } from 'lucide-react';

interface ScanIntroHeroProps {
  onStartScan: () => void;
}

const ScanIntroHero: React.FC<ScanIntroHeroProps> = ({ onStartScan }) => {
  return (
    <section className="bg-gradient-to-b from-brand-lightBlue to-white py-20 md:py-24 relative overflow-hidden">
      <div className="absolute inset-0 opacity-10">
        <img 
          src="https://images.unsplash.com/photo-1560250097-0b93528c311a?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=774&q=80" 
          alt="Belgische ondernemer" 
          className="w-full h-full object-cover" 
        />
      </div>
      <div className="container">
        <div className="max-w-3xl mx-auto text-center relative z-10 pt-16">
          <Card className="bg-white/80 backdrop-blur-sm border-none shadow-xl">
            <CardHeader>
              <div className="mx-auto mb-4 p-3 bg-brand-lightBlue rounded-full w-16 h-16 flex items-center justify-center">
                <TrendingUp className="h-8 w-8 text-brand-blue" />
              </div>
              <CardTitle className="text-4xl md:text-5xl font-bold text-gray-900">
                Is jouw organisatie klaar om meer klanten aan te trekken?
              </CardTitle>
              <CardDescription className="text-xl text-gray-700 mt-4">
                Doe de gratis telemarketing scan en ontdek in 3 minuten of jouw bedrijf klaar is voor externe afspraakplanning.
              </CardDescription>
            </CardHeader>
            <CardFooter className="flex justify-center pb-8">
              <Button 
                onClick={onStartScan} 
                variant="highlight"
                size="xl"
                className="group transition-all duration-300"
              >
                Start de scan
                <ChevronRight className="ml-2 group-hover:translate-x-1 transition-transform duration-300" />
              </Button>
            </CardFooter>
          </Card>
        </div>
      </div>
    </section>
  );
};

export default ScanIntroHero;
